export class CmsAlarms {
  alarms: CmsAlarm[];
  maxNumberOfRows: number;

  static mapPortfolio(data: any) {
    if (data) {
      return new CmsAlarms({
        alarms: data.cmsAlarms.map(a => {
          const alarm: CmsAlarm = {
            turbineSerial: a.turbineSerial,
            turbineSerialNav: a.turbineSerialNav,
            turbineCode: a.turbineCode,
            temp: a.temp,
            status: a.status,
            detectionTS: a.detectionTS,
            description: a.description,
            trend: a.trend,
            deviation: a.deviation * 100,
            tempAvg: a.tempAvg,
            signal: a.signal,
            signalName: a.signalName
          };
          return alarm;
        }).sort((a, b) => a.detectionTS > b.detectionTS ? -1 : 1),
        maxNumberOfRows: data.parks.length
      });
    } else {
      return null;
    }
  }

  static mapPark(data: any) {
    if (data) {
      return new CmsAlarms({
        alarms: data.cmsAlarms.map(a => {
          const alarm: CmsAlarm = {
            turbineSerial: a.turbineSerial,
            turbineSerialNav: a.turbineSerialNav,
            turbineCode: a.turbineCode,
            temp: a.temp,
            status: a.status,
            detectionTS: a.detectionTS,
            description: a.description,
            trend: a.trend,
            deviation: a.deviation * 100,
            tempAvg: a.tempAvg,
            signal: a.signal,
            signalName: a.signalName
          };
          return alarm;
        }).sort((a, b) => a.detectionTS > b.detectionTS ? -1 : 1),
        maxNumberOfRows: data.turbines.length
      });
    } else {
      return null;
    }
  }

  static mapTurbine(data: any) {
    if (data) {
      return new CmsAlarms({
        alarms: data.cmsAlarms.map(a => {
          const alarm: CmsAlarm = {
            turbineSerial: a.turbineSerial,
            turbineSerialNav: a.turbineSerialNav,
            turbineCode: a.turbineCode,
            temp: a.temp,
            status: a.status,
            detectionTS: a.detectionTS,
            description: a.description,
            trend: a.trend,
            deviation: a.deviation * 100,
            tempAvg: a.tempAvg,
            signal: a.signal,
            signalName: a.signalName
          };
          return alarm;
        }).sort((a, b) => a.detectionTS > b.detectionTS ? -1 : 1),
        maxNumberOfRows: 5
      });
    } else {
      return null;
    }
  }

  constructor(init: Partial<CmsAlarms>) {
    Object.assign(this, init);
  }

}

interface CmsAlarm {
  turbineSerial: string;
  status: number;
  detectionTS: number;
  description: string;
  trend: string;
  deviation: number;
  tempAvg: number;
  signalName: string;
  signal: string;
  turbineCode: string;
  temp: number;
  turbineSerialNav: number;
}
